import './shop.js.erb'
import './polyfills'
import FlashNotice from './flash_notice'
import popupInit from './popupInit'
import validationFormInit from './validationFormInit'
import initSocialLikes from './socialLikes'
import initNotification from './notifications'
import initSliders from './photo-slider'
import cartForm from './cart_form'
import initBoxberry from "./boxberry";
import initCdek from "./cdek";

function initCityBanner() {
  var modal      = document.getElementById('city-modal');
  var modalInput = document.getElementById('city-modal-input');
  var modalList  = document.getElementById('city-modal-suggestions');
  var modalClose = document.getElementById('city-modal-close');
  if (!modal) return;

  var searchTimer;

  function openCityModal() {
    modal.style.display = 'flex';
    setTimeout(function() { modalInput.focus(); }, 100);
  }

  function closeCityModal() {
    modal.style.display = 'none';
    modalInput.value = '';
    modalList.style.display = 'none';
    modalList.innerHTML = '';
  }

  function updateHeaderCity(cityName) {
    var el = document.getElementById('header-city-name');
    if (el) el.textContent = cityName;
  }

  function getCookieCity() {
    var match = document.cookie.split('; ').find(function(r) { return r.startsWith('user_city='); });
    if (!match) return null;
    try { return JSON.parse(decodeURIComponent(match.split('=').slice(1).join('='))); } catch(e) { return null; }
  }

  function saveCity(cityName, cityCode) {
    if (cityCode) {
      // Код уже известен — сохраняем сразу
      fetch('/api/city/confirm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: cityName, cdek_city: cityName, cdek_code: cityCode })
      }).then(function() {
        updateHeaderCity(cityName);
        closeCityModal();
      });
    } else {
      // Ищем код в CDEK
      fetch('/api/city/search?q=' + encodeURIComponent(cityName))
        .then(function(r) { return r.json(); })
        .then(function(cities) {
          var found = cities && cities[0];
          var city = {
            name:      found ? found.name : cityName,
            cdek_city: found ? found.name : cityName,
            cdek_code: found ? found.code : null
          };
          return fetch('/api/city/confirm', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(city)
          }).then(function() {
            updateHeaderCity(city.name);
            closeCityModal();
          });
        });
    }
  }

  // Читаем куку и показываем город в шапке
  var cookieCity = getCookieCity();
  if (cookieCity) updateHeaderCity(cookieCity.name);

  // Клик по городу в шапке
  var headerCityLink = document.getElementById('header-city-link');
  if (headerCityLink) {
    headerCityLink.addEventListener('click', function(e) {
      e.preventDefault();
      openCityModal();
    });
  }

  // Listeners модала
  modalClose.addEventListener('click', closeCityModal);

  modal.addEventListener('click', function(e) {
    if (e.target === modal) closeCityModal();
  });

  modalInput.addEventListener('input', function() {
    clearTimeout(searchTimer);
    var q = modalInput.value.trim();
    if (q.length < 2) { modalList.style.display = 'none'; return; }
    searchTimer = setTimeout(function() {
      fetch('/api/city/search?q=' + encodeURIComponent(q))
        .then(function(r) { return r.json(); })
        .then(function(cities) {
          modalList.innerHTML = '';
          if (!cities.length) { modalList.style.display = 'none'; return; }
          cities.forEach(function(city) {
            var li = document.createElement('li');
            li.style.cssText = 'padding:0.6rem 1rem;cursor:pointer;font-size:14px;border-bottom:1px solid #f0f0f0;color:#333;';
            li.textContent = city.region ? city.region + ', ' + city.name : city.name;
            li.addEventListener('mouseenter', function() { li.style.background = '#f7f7f7'; });
            li.addEventListener('mouseleave', function() { li.style.background = ''; });
            li.addEventListener('click', function() { saveCity(city.name, city.code); });
            modalList.appendChild(li);
          });
          modalList.style.display = 'block';
        });
    }, 300);
  });

  modalInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      var first = modalList.querySelector('li');
      if (first) first.click();
    }
  });

  // Популярные города
  document.querySelectorAll('.city-modal__popular-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      saveCity(btn.dataset.city, parseInt(btn.dataset.code));
    });
  });

if (!cookieCity) {
  fetch('https://suggestions.dadata.ru/suggestions/api/4_1/rs/iplocate/address', {
    method: 'GET',
    headers: {
      'Accept':        'application/json',
      'Authorization': 'Token ' + window.DADATA_API_KEY
    }
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    var city = data && data.location && data.location.data && data.location.data.city;
    var cityName = city || 'Москва';
    var cityCode = city ? null : 44;
    updateHeaderCity(cityName);
    saveCity(cityName, cityCode);
  })
  .catch(function() {
    updateHeaderCity('Москва');
    saveCity('Москва', 44);
  });
}
}

document.addEventListener('turbolinks:load', function() {
  initCityBanner();
  new FlashNotice()
  initSocialLikes()
  popupInit()
  validationFormInit()
  initNotification()
  initSliders()
  cartForm()
  initBoxberry()
  initCdek()
})

